// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nV1U","newExpiryDate":"styles_newExpiryDate__25DiE","footer":"styles_footer__3Mts9"};